<template>
  <div class="informationTemplate-tree-bd">
    <custom-dialog
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
      width="500px"
    >
      <div class="dialog-body">
        <!-- 用户信息 -->
        <el-form :model="form" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('crm_renter_contactsBusiness_dialog.xmfzrmc')" prop="contactName" :rules="rules.contactName">
                <el-input v-model.trim="form.contactName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
             <el-form-item :label="$t('crm_renter_contactsBusiness_dialog.xmfzrdh')" prop="mobilePhone" :rules="rules.mobilePhone">
                <el-input v-model.trim="form.mobilePhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
             <el-form-item :label="$t('crm_renter_contactsBusiness_dialog.xmfzryx')" prop="email" :rules="rules.email">
                <el-input v-model.trim="form.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveContact">{{ $t('Common.com_confirm')}}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // 用于编辑
      form: {
        contactName: '',
        post: '',
        mobilePhone: '',
        email: '',
        // id
        contactId: '',
        partnerId: '',
        partnerOrgId: '',
        contactType: 'busleader'
      },
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.initDialog();
    this.rules.mobilePhone[1].validator = this.$mobilePhoneValidator;
  },

  computed: {
    rules() {
      return {
        contactName: [
          { required: true, message: this.$t('crm_renter_contactsBusiness_dialog.qtxywymc') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) }
        ],
        mobilePhone: [
          { required: true, message: this.$t('crm_renter_contactsBusiness_dialog.qtxywydh') },
          { validator: null, message: this.$t('crm_renter_contactsBusiness_dialog.qsrzqdlxrdh') }
        ],
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('crm_renter_contactsBusiness_dialog.qtxzqdyx')
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) }
        ]
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      // this.$nextTick(() => {
      //   this.visible = true;
      // });
      this.form = JSON.parse(this.resetForm);
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      if (this.model.type === 'add') {
        // 清空重置值
        this.form.partnerId = this.model.data.partnerId;
        this.form.partnerOrgId = this.model.data.partnerOrgId;
      }
      if (this.model.type === 'edit') {
        // 赋值
        this.$setFormatData(this.form, this.model.data);
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveContact: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddContact();
        }
        if (this.model.type === 'edit') {
          this.saveEditContact();
        }
      });
    },
    // 保存新增业务员
    saveAddContact: function () {
      // this.formContact.partnerCoopcontacts = [this.form];
      this.form.partnerId = this.model.data.partnerId;
      this.form.partnerOrgId = this.model.data.partnerOrgId;
      this.form.contactType = 'busleader';// 业务联系人
      this.$postJSON(apis.partnerContactAdd, this.form).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success'
          });
          this.$emit('success');
          this.closeDialog();
        }
      });
    },
    // 保存编辑业务员
    saveEditContact: function () {
      this.$postJSON(`${apis.partnerContactUpdate}`, this.form).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success'
          });
          this.$emit('success', this.form);
          this.closeDialog();
        }
      });
    }
  }
};
</script>

<style lang="scss">
</style>
